import { createAxiosClient } from 'src/utils/axiosClient';
import Stripe from 'stripe';

/**
 * Panacea Service client for internal calls
 */
export const panaceaClient = createAxiosClient({
  baseURL: process.env.PANACEA_INTERNAL_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Mealogic-API-Key': process.env.PANACEA_INTERNAL_API_KEY,
  },
});

/**
 *
 * GET `/v1/payments/stripe/checkout-session-completed/:sessionId`
 *
 * Retrieves the completed checkout session from Stripe. Currently used to display on the confirmation page.
 */
export const getStripeCheckoutSessionCompleted = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<Stripe.Response<Stripe.Checkout.Session>> => {
  const { data } = await panaceaClient.get<
    Stripe.Response<Stripe.Checkout.Session>
  >(`/v1/payments/stripe/get-completed-checkout-session?id=${sessionId}`);
  return data;
};

/**
 * Panacea Service client for public API calls
 */
export const panaceaPublicClient = createAxiosClient({
  baseURL: process.env.NEXT_PUBLIC_PANACEA_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
});
